<template>
    <div class="xc-page xc-page-sandwich" @click="hideTree">
        <div class="xc-page-main">
            <!-- 面包屑 -->
            <div class="xc-breadcrumb">
                <router-link :to="$config.adminPath + '/device/state/statistic'">报表统计</router-link>
                <a>设备状态</a>
            </div>

            <!-- 表格 -->
            <div class="xc-row xc-s-flex">
                <div class="xc-card">
                    <div class="xc-card-content">
                        <form class="xc-form">
                            <div class="xc-form-inline">
                                <xc-form-item label="终端组：" labelWidth="0">
                                    <div class="select-content">
                                        <div class="xc-select xc-tree-select" @click.stop="chooseDeviceTree">
                                            <span>
                                                {{groupName?groupName:'请选择'}}
                                            </span>
                                        </div>
                                        <div class="device-tree" v-show="showTree">
                                            <div class="tree xc-s-p" @click.stop="">
                                                <div v-if="treeList.length">
                                                    <xc-tree :data.sync="treeList" @checked="checkFunc" label="name" show-checkbox linked :expand="0" multiple></xc-tree>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </xc-form-item>
                                <div class="xc-btn-group">
                                    <button type="submit" class="xc-btn xc-btn-primary" @click.prevent="mix_search">查询</button>
                                </div>
                            </div>
                        </form>

                        <!-- 带滚动条的表格 -->
                        <div class="xc-row-scroll">
                            <table class="xc-table">
                                <thead>
                                    <tr>
                                        <th>终端组</th>
                                        <th>设备序列号</th>
                                        <th>设备MAC</th>
                                        <th>设备IP</th>
                                        <th>在线状态</th>
                                        <th>上网方式</th>
                                        <th>操作</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-if="list && list.length">
                                        <tr v-for="(item,key) in list" :key="key">
                                            <td>
                                                {{item.groupName}}
                                            </td>
                                            <td>
                                                {{item.deviceSerialNum}}
                                            </td>
                                            <td>
                                                {{item.deviceMac}}
                                            </td>
                                            <td>
                                                {{item.lastReportIp}}
                                            </td>
                                            <td>
                                                {{item.deviceStatus}}
                                            </td>
                                            <td>
                                                {{item.networkingWay}}
                                            </td>
                                            <td>
                                                <div class="xc-link">
                                                    <a @click="action('getDeviceDetail',item,$event)">明细</a>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-else>
                                        <tr>
                                            <td colspan="9 " class="xc-s-tac">暂无数据</td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 固低栏 -->
        <div class="xc-page-footer">
            <!-- 分页 -->
            <xc-pagination @change="mix_pageChange" :page="mix_page" :total="mix_total" :size="mix_pageSize" />
        </div>

        <!-- 明细 -->
        <div class="xc-modal xc-modal-dialog" v-if="modalName == 'onlineLog'">
            <div class="xc-modal-mask" @click="modalName = null"></div>
            <div class="xc-modal-wrap xc-anim-scaleIn">
                <div class="xc-modal-content">
                    <div class="xc-modal-header">
                        <div class="xc-modal-title">上线日志</div>
                        <div class="xc-modal-close" @click="modalName = null"></div>
                    </div>
                    <div class="xc-modal-body">
                        <div class="xc-form-inline">
                            <div class="xc-form-item xc-form-item-required">
                                <div class="xc-form-item-label">
                                    <label>时间</label>
                                </div>
                                <div class="xc-form-item-content">
                                    <input type="text" maxlength="255" class="time xc-input" placeholder="选具体某天（不能选当天）" v-model="time">
                                </div>
                            </div>
                            <div class="xc-form-inline">
                                <button type="submit" class="xc-btn xc-btn-primary" @click.prevent="mix_search">查询</button>
                            </div>
                        </div>

                        <!-- 带滚动条的表格 -->
                        <div class="xc-row-scroll">
                            <table class="xc-table">
                                <thead>
                                    <th>终端组</th>
                                    <th>设备MAC</th>
                                    <th>设备IP</th>
                                    <th>上线时间</th>
                                    <th>离线时间</th>
                                    <th>在线时长</th>
                                </thead>
                                <tbody>
                                    <template v-if="deviceValue && deviceValue.length">
                                        <tr v-for="(item,key) in deviceValue" :key="key">
                                            <td>
                                                {{item.terminalGroup}}
                                            </td>
                                            <td>
                                                {{item.deviceSerialNumber}}
                                            </td>
                                            <td>
                                                {{item.deviceMAC}}
                                            </td>
                                            <td>
                                                {{item.PublishedTime}}
                                            </td>
                                            <td>
                                                {{item.underTime}}
                                            </td>
                                            <td>
                                                {{item.onlineTime}}
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-else>
                                        <tr>
                                            <td colspan="9" class="xc-s-tac">暂无数据</td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="xc-modal-footer xc-modal-footer-style">
                        <div class="xc-btn-group">
                            <div class="xc-btn xc-btn-default" @click="modalName = null">取消</div>
                            <div class="xc-btn xc-btn-primary" @click="modalName = null">提交</div>
                        </div>
                        <div>
                            <xc-pagination @change="mix_pageChange" :page="mix_page" :total="mix_total" :size="mix_pageSize" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import listMixin from "@/xc-ui/mixins/list";
import flatPickr from '@/libs/flatpickr';
import deviceApi from "../api/device";
import reportFormApi from "../api/report-forms";
import myLayerImport from '@/libs/myLayer';
export default {
    name: "exampleList",
    mixins: [listMixin],
    data() {
        return {
            // 弹出窗
            modalName: null,
            time: null,
            // 列表key
            mix_listKey: "list",

            // 列表唯一字段
            mix_listId: "departmentId",

            // 列表数据
            list: [],

            // 默认查询参数
            mix_query: {
            },

            treeList: [],

            // 上线日志
            deviceValue: [
            ],

            // 显示树形列表
            showTree: false,

            // 选择的终端名称
            groupName: ''
        };
    },

    async created() {
        // 加载JS
        await myLayerImport();

        let that = this
        //初始化时间选择
        this.$nextTick(function () {
            flatpickr(".time")
        })

        // 获取树形分组
        this.getTree()
    },

    mounted() {
        let that = this
    },

    methods: {
        // 获取终端树形分组
        getTree() {
            let that = this;
            deviceApi.getDeviceGroup().then(v => {
                const deviceGroupList = v.data
                deviceGroupList[0] = {
                    ...deviceGroupList[0],
                    active:false,
                }
                that.deviceGroupList = deviceGroupList
                that.treeList = deviceGroupList
            });
        },

        // 点击空白关闭树形框
        hideTree() {
            this.showTree = false
        },

        // 点击选择框事件
        chooseDeviceTree() {
            this.showTree = !this.showTree;
        },

        // 点击树形选择框的回调
        checkFunc: function (data) {
            let idArr = []
            let nameArr = []
            for (let i of data.checked) {
                idArr.push(i.id)
                nameArr.push(i.name)
            }
            this.mix_query.groupId = idArr.join(",")
            this.groupName = nameArr.join(",")
        },

        // 查看明细
        viewDetail() {
            this.$nextTick(function () {
                flatpickr(".time")
            })
            this.modalName = "onlineLog"
        },

        // 初始化数据
        initData() {
            // 默认搜索的数据
            const search = {
                pageNum: this.mix_page,
                pageSize: this.mix_pageSize,
                ...this.mix_query
            };

            deviceApi.getDeviceList(search).then(v => {
                let ret = v
                this.list = this.mix_format(ret.data.list);
                this.mix_total = ret.data.total;
                this.mix_page = ret.data.pageNum;
                this.mix_pageSize = ret.data.pageSize;
            })
        },

        // 操作单条数据
        action(...args) {
            const [action, item, index] = args;
            const e = args[args.length - 1];
            // 获取设备序列号
            let deviceCode = item.deviceCode
            switch (action) {
                // 获取终端列表详情
                case "getDeviceDetail":
                    myLayer.open({
                        type: 2,
                        title: false,
                        shadeClose: true,
                        closeBtn: 0, //不显示关闭按钮
                        area: ['981px', '550px'],
                        content: this.$config.adminPath + '/device/state/:deviceId/detail?deviceCode='+ deviceCode,
                        success: function (layero,index) {

                        }
                    });
                    break;
                default: break;
            }
        },
    }
};
</script>

<style scoped lang="scss">

.xc-modal-footer-style {
    display: flex;
    justify-content: space-between;
    padding: 0 15px;
}

// 多选样式
// 去掉input框focus默认样式
*:focus { outline: none; }

.select-content {
    position: relative;
}

.xc-select {
    display: flex;
    align-items: center;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    position: relative;
}

.xc-select::before {
    position: absolute;
    right: 4px;
    top: 8px;
    content: '';
    width: 0;
    height: 0;
    border-left: 3.5px solid transparent;
    border-right: 3.5px solid transparent;
    border-bottom: 6px solid #808b9e;
}

.xc-select::after {
    position: absolute;
    right: 4px;
    bottom: 8px;
    content: '';
    width: 0;
    height: 0;
    border-left: 3.5px solid transparent;
    border-right: 3.5px solid transparent;
    border-top: 6px solid #808b9e;
}

.xc-tree-select span {
    width: 100%;
    box-sizing: border-box;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.device-tree {
    position: absolute;
    left: 0;
    top: 31px;
    background: #ffffff;
    z-index: 99999;
    border: solid 1px #cfd5e0;
    width: 100%;
    border-radius: 5px;
    overflow: auto;
    max-height: 300px;
    padding: 12px 10px 0px 12px;
    box-sizing: border-box;
}

.xc-s-p {
    padding: 0;
}

</style>
